<template>
  <div
    class="my-10 grid grid-cols-1 md:grid-cols-12 gap-4 w-full max-w-6xl mx-auto"
  >
    <!-- Show only on laptop/desktop -->
    <div class="hidden lg:block lg:col-span-3">
      <HeroProfile />
    </div>

    <!-- Responsive: full width on mobile/tablet, 8 cols when HeroProfile is shown -->
    <div class="md:col-span-12 lg:col-span-9">
      <HeroConsult :ifHaveCurrentCons="itemTransaction.length ? true : false" />
    </div>
  </div>
  <div class="w-full max-w-6xl mx-auto px-4 sm:px-0">
    <h2 class="text-xl font-semibold text-gray-600 pb-4">
      Current Consultation
    </h2>

    <div class="flex items-center justify-center h-48" v-if="isLoading">
      <svg
        class="w-10 h-10 animate-spin text-orange-600"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        ></path>
      </svg>
    </div>
    <div v-else>
      <div v-if="!itemTransaction.length" class="text-sm text-zinc-500">
        You don’t have any ongoing consultations right now.
      </div>
      <div
        v-else
        class="rounded-xl border-neutral-200 shadow-[0_10px_50px_rgba(0,0,0,0.1)] overflow-hidden bg-white"
      >
        <ul role="list" class="divide-y divide-gray-200">
          <li
            v-for="(item, index) in itemTransaction"
            :key="index"
            class="flex items-center justify-between px-6 py-4"
          >
            <div class="flex items-center gap-4">
              <div class="flex flex-col justify-center items-center">
                <span>{{ monthFormat(item.createdat) }}</span>
                <span>{{ dayFormat(item.createdat) }}</span>
              </div>
              <div>
                <p class="text-xs text-zinc-700">Transaction Number</p>
                <p class="text-sm font-medium text-orange-600">
                  {{ item.transactionid }}
                </p>
              </div>
            </div>
            <div class="text-right">
              <p class="text-sm text-gray-900 flex justify-end">
                <button
                  @click="routeTransaction(item.transactionid)"
                  class="inline-flex items-center gap-2 px-4 py-2 bg-orange-50 border border-orange-400 text-orange-500 hover:bg-hover hover:text-white text-sm font-medium rounded-md transition"
                >
                  View
                </button>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import HeroProfile from "@/components/common/portal/HeroProfile.vue";
import HeroConsult from "@/components/common/portal/HeroConsult.vue";
import { onMounted, ref, inject, watch } from "vue";
export default {
  components: {
    HeroProfile,
    HeroConsult,
  },
  props: {
    isTransaction: Boolean,
  },
  emits: ["checkIfhaveTrans"],
  setup(props, { emit }) {
    const store = inject("$store");
    const moment = inject("$moment");
    const axios = inject("$axios");
    const router = inject("$router");
    const itemTransaction = ref([]);
    const showModal = ref(false);
    const isLoading = ref(false);

    onMounted(() => {
      initiateCheckIfActiveHandler();
      initiateTransaction();
    });
    const initiateCheckIfActiveHandler = async () => {
      try {
        const { data } = await axios.get(
          `/api/patient/checkifvalidate/status/${store.state.userControlNumber}`
        );
        store.state.userMembershipStatus = data[0].status;
      } catch (err) {
        console.log(err);
      }
    };
    const initiateTransaction = async () => {
      try {
        isLoading.value = true;
        const { data } = await axios.get(`/api/patient/transaction`);
        emit("checkIfhaveTrans", data.data.length ? true : false);
        itemTransaction.value = data.data;

        setTimeout(() => {
          isLoading.value = false;
        }, 800);
      } catch (err) {
        console.log(err);
      }
    };
    const monthFormat = (val) => {
      return moment(val).format("MMM");
    };
    const dayFormat = (val) => {
      return moment(val).format("DD");
    };
    const routeTransaction = (val) => {
      router.push(`/portal/transaction/${val}`);
    };

    return {
      itemTransaction,
      initiateCheckIfActiveHandler,
      initiateTransaction,
      monthFormat,
      dayFormat,
      routeTransaction,
      showModal,
      isLoading,
    };
  },
};
</script>
